var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89985 0.0996094L19.7988 1.51461L21.2128 11.4146L12.0208 20.6066C11.8333 20.7941 11.579 20.8994 11.3138 20.8994C11.0487 20.8994 10.7944 20.7941 10.6068 20.6066L0.706849 10.7066C0.519378 10.5191 0.414063 10.2648 0.414062 9.99961C0.414063 9.73444 0.519378 9.48014 0.706849 9.29261L9.89985 0.0996094ZM10.6068 2.22161L2.82785 9.99961L11.3138 18.4846L19.0918 10.7066L18.0318 3.28161L10.6068 2.22161ZM12.7268 8.58561C12.3517 8.21033 12.141 7.70139 12.1411 7.17076C12.1411 6.90801 12.1929 6.64785 12.2935 6.40513C12.3941 6.1624 12.5415 5.94186 12.7273 5.75611C12.9132 5.57035 13.1338 5.42302 13.3765 5.32251C13.6193 5.22201 13.8795 5.1703 14.1422 5.17035C14.6728 5.17044 15.1817 5.38133 15.5568 5.75661C15.932 6.13189 16.1427 6.64083 16.1426 7.17146C16.1425 7.7021 15.9316 8.21096 15.5563 8.58611C15.1811 8.96126 14.6721 9.17196 14.1415 9.17187C13.6109 9.17177 13.102 8.96089 12.7268 8.58561Z",
    fill: "#09121F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellTag);
export default __webpack_public_path__ + "static/media/sell-tag.e5364caf.svg";
export { ForwardRef as ReactComponent };